// global/guest-cookie.lib

function setGuestCookieIfNeeded() {
    if (typeof Cookies.get('guest_id') == 'undefined') {
        Cookies.set('guest_id', randomString(32), { expires: 365*100, domain: global_tokyvideo_cookie_lang_domain });
    }
    if(typeof global_tokyvideo_type_url !== "undefined"){
        Cookies.set('url_type',global_tokyvideo_type_url, { expires: 365*100, domain: global_tokyvideo_cookie_lang_domain, sameSite: 'none', secure: true });
        //Cookies.set('url_type',global_tokyvideo_type_url, { expires: 365*100 });
        //Cookies.remove('url_type_id');
    }
    if(typeof global_tokyvideo_video_id !== "undefined"){
        Cookies.set('url_type_id',global_tokyvideo_video_id, { expires: 365*100, domain: global_tokyvideo_cookie_lang_domain, sameSite: 'none', secure: true});
        //Cookies.set('url_type_id',global_tokyvideo_video_id, { expires: 365*100 });
    }
    if( typeof global_tokyvideo_serie_id !== "undefined"){
        Cookies.set('url_type_id',global_tokyvideo_serie_id, { expires: 365*100, domain: global_tokyvideo_cookie_lang_domain, sameSite: 'none', secure: true});
        //Cookies.set('url_type_id',global_tokyvideo_serie_id, { expires: 365*100 });
    }
}

function removeGuestCookieIfNeeded() {
    if (typeof Cookies.get('guest_id') != 'undefined') {
        Cookies.remove('guest_id', { domain: global_tokyvideo_cookie_lang_domain });
    }
}

function randomString(length) {
    var str = '';
    var chars ='0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz'.split('');
    var charsLen = chars.length;
    
    if (! length) {
        length = ~~(Math.random() * charsLen);
    }
    
    for (var i = 0; i < length; i++) {
        str += chars[~~(Math.random() * charsLen)];
    }
    
    return str;
}
